// Filter-related types and enums for Inbox functionality
import { ReactNode } from "react";

export enum FilterType {
  ALL = "all",
  CHATS = "chats",
  STARRED = "starred",
  ARCHIVED = "archived",
}

export interface HeaderInfo {
  title: string;
  description: string;
  icon: ReactNode;
}
